





















































































import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  computed,
  onBeforeUnmount,
} from '@vue/composition-api';
import {
  Button, Toast, Checkbox, Dialog,
} from '@hb/coffee';
import {
  ContractItemDetail,
  CreditMallFromEnum,
  ContractContentTypeEnum,
  MiddleIncomeContractListResponse,
  MiddleIncomeDispatchResponse,
  PageStatusEnum,
  ProductContractList,
} from '@/api/middle-income/types';
import { ChannelContractInfo, ContractTypeEnum } from '@/widgets/contract-view/type';
import { applyMiddleIncomeCredit } from '@/api/middle-income';

import { openThirdPage } from '@/api/native/utils';
import { ubtModuleExposeNew, ubtPageButtonNew } from '@/shared/utils/ubt';
import router from '@/router';
import { VerifySceneEnum, OpenVerifyPageMode } from '@/shared/verify-credit-controller/types';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import ChannelContract from '@/widgets/contract-view/channel-contract/index.vue';
import channelContractTabs from '@/widgets/contract-view/channel-contract-tabs/index.vue';
import ContractView from '../contract-view/flatten-contract/index.vue';
import { pollingStatus } from '../middle-income-card/pollingStatus';
import {
  shopMallAgreementPopupClick,
  shopMallAgreementPopupExpose,
  dcHalfApplyAgreementClick,
  dcHalfApplyAgreementExpose,
} from '../middle-income-card/tianqi';


export default defineComponent({
  components: {
    ContractView,
    ChannelContract,
    channelContractTabs,
    Checkbox,
    Button,
  },
  props: {
    /** 完整分发结果 */
    dispatchResult: {
      type: Object as PropType<MiddleIncomeDispatchResponse | undefined>,
      default: undefined,
    },
    /** 完整协议结果 */
    protocolResult: {
      type: Object as PropType<MiddleIncomeContractListResponse | undefined>,
      default: undefined,
    },
    /** 来源标识 */
    from: {
      type: String as PropType<CreditMallFromEnum>,
      default: CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
    },
    /** 场景标识 */
    scene: {
      type: String,
      default: '',
    },
    /** 资料是否不完整，true 不完整，false 完整 */
    incompleteInfo: {
      type: Boolean,
      default: false,
    },
    /** 最高可申请金额 */
    applyAmount: {
      type: String,
      default: '200000',
    },
  },
  emits: ['apply-success', 'apply-fail'],
  setup(props, { emit }) {
    /** 倒计时秒数 */
    const countdown = ref(5);
    /** 倒计时定时器 */
    let countdownTimer: number | null = null;
    /** 授信状态 */
    const creditStatus = ref<PageStatusEnum | undefined>(undefined);
    /** 成功跳转地址 */
    const successJumpUrl = ref<string>('');
    const taskId = ref<string>('');

    const pickCommodityIds = (list?: Array<{ commodityId: string }>) => (
      (list || []).map((i) => i.commodityId)
    );
    /**
     * 基于协议结果拆分协议列表：
     * - 商城协议列表：protocolResult.shoppingMallContractList
     * - 半流程协议列表：protocolResult.overLoanContractList
     *
     * 有商城无半流程 → 返回商城；有半流程无商城 → 返回半流程；两者都有 → 拼接（商城在前）
     */
    const shoppingMallContractList = computed<ProductContractList[]>(() => (
      props.protocolResult?.shoppingMallContractList || []
    ));

    /**
     * 商城协议列表合并：当数组长度 > 1 时，将后续项的 contractList 拼接到第一项的 contractList，只保留第一项
     * 纯做数据展示用，下单不从这里取渠道id
     */
    const mergedShoppingMallContractList = computed<ProductContractList[]>(() => {
      const list = shoppingMallContractList.value;
      if (list.length <= 1) return list;
      const [first, ...rest] = list;
      const mergedContractList = (first.contractList || []).concat(
        ...rest.map((item: ProductContractList) => item.contractList || []),
      );
      const newList = { ...first, contractList: mergedContractList };
      return [newList];
    });

    const semiProcessContractList = computed<ProductContractList[]>(() => (
      props.protocolResult?.overLoanContractList || []
    ));

    /** 纯贷超列表（本地协议列表，添加选中状态） */
    const pureOverLoanLocalChannelList = ref<ChannelContractInfo[]>([]);

    /** 处理纯贷超半流程协议，勾选逻辑 */
    const handleSelectChannel = (
      { productId, isSelected }: { productId: string; isSelected?: boolean },
    ) => {
      const channel = pureOverLoanLocalChannelList.value.find((c) => c.productId === productId);
      if (channel) {
        // 内部切换选中状态
        channel.isSelected = !isSelected;
      }
    };


    const hasAnyContract = (list?: ProductContractList[]): boolean => (
      (list || []).some((product) => (product.contractList || []).length > 0)
    );

    /** 是否有商城协议 */
    const hasShoppingMallProtocol = computed(() => hasAnyContract(shoppingMallContractList.value));
    /** 是否有半流程协议 */
    const hasSemiProcessProtocol = computed(() => hasAnyContract(semiProcessContractList.value));

    /** 1 纯商城协议 */
    const isPureShoppingMallProtocol = computed(() => (
      hasShoppingMallProtocol.value && !hasSemiProcessProtocol.value
    ));
    /** 2 纯半流程协议 */
    const isPureSemiProcessProtocol = computed(() => (
      hasSemiProcessProtocol.value && !hasShoppingMallProtocol.value
    ));
    /** 3 商城 + 半流程协议 */
    const isShoppingMallAndSemiProcessProtocol = computed(() => (
      hasShoppingMallProtocol.value && hasSemiProcessProtocol.value
    ));

    /** 顶部说明区文案：纯商城 / 纯贷超 / 商城+贷超 三种情况不同 */
    const tipsCopy = computed(() => {
      if (isPureShoppingMallProtocol.value) {
        return '为更便捷的提供服务，请您充分知悉，以下将为您提供信用付额度，可用于分期商城购买商品。当然，您还可主动选择其他更多借款额度机构，匹配越多意味着可能获得越高额度。';
      }
      if (isPureSemiProcessProtocol.value) {
        return '我们安排以下资方为您提供额度，越多的资方意味着可能获得越高的额度，必要时您可主动选择资方。为更好的提供服务，将同时为您发起申请。';
      }
      if (isShoppingMallAndSemiProcessProtocol.value) {
        return '为更便捷的提供服务，请您充分知悉，以下将为您提供信用付额度，可用于分期商城购买商品。当然，您还可主动选择其他更多借款额度机构，匹配越多意味着可能获得越高额度。';
      }
      return '为更便捷的提供服务，请您充分知悉，以下将为您提供信用付额度，可用于分期商城购买商品。当然，您还可主动选择其他更多借款额度机构，匹配越多意味着可能获得越高额度。';
    });

    /**
     * 商城 + 贷超同时存在时：贷超是否勾选
     * 默认勾选；贷超相关埋点后续单独接入
     */
    const isOverLoanSelectedWhenBoth = ref(false);

    /**
     * 从协议列表里提取“有协议内容”的产品ID（用于授信申请参数）
     */
    const pickProductIdsFromProtocolList = (list?: ProductContractList[]): string[] => (
      (list || [])
        .filter((channel) => !!channel.productId && (channel.contractList || []).length > 0)
        .map((channel) => channel.productId as string)
    );

    /** 商城协议列表过滤后的产品ID */
    const shoppingMallProtocolProductIds = computed<string[]>(() => (
      pickProductIdsFromProtocolList(shoppingMallContractList.value)
    ));

    /** 半流程协议列表过滤后的产品ID */
    const semiProcessProtocolProductIds = computed<string[]>(() => (
      pickProductIdsFromProtocolList(semiProcessContractList.value)
    ));

    const flattenProductContractList = (list?: ProductContractList[]): ContractItemDetail[] => (
      (list || []).reduce<ContractItemDetail[]>((acc, product) => (
        acc.concat(product.contractList || [])
      ), [])
    );

    const contractListFromProtocolResult = computed<ContractItemDetail[]>(() => {
      const mallContracts = flattenProductContractList(shoppingMallContractList.value);
      const semiContracts = flattenProductContractList(semiProcessContractList.value);
      if (mallContracts.length > 0 && semiContracts.length === 0) {
        return mallContracts;
      }
      if (semiContracts.length > 0 && mallContracts.length === 0) {
        return semiContracts;
      }
      return mallContracts.concat(semiContracts);
    });

    /** 商城产品ID列表（用于当前埋点，贷超埋点后续单独接入） */
    const shoppingMallProductIds = computed<string[]>(() => (
      pickCommodityIds(props.dispatchResult?.shoppingMallCommodities)
    ));

    /** 半流程产品ID列表（用于授信申请参数） */
    const semiProcessProductIds = computed<string[]>(() => (
      pickCommodityIds(props.dispatchResult?.overLoanCommodities)
    ));

    /** 格式化金额 */
    const formatAmount = computed(() => {
      const amount = props.applyAmount;
      if (typeof amount === 'number' || (typeof amount === 'string' && Number(amount))) {
        return Number(amount).toLocaleString();
      }
      return amount;
    });

    /** 适配协议列表数据格式 */
    const adaptedContractList = computed(() => (
      (contractListFromProtocolResult.value || []).map((item: ContractItemDetail) => {
        const anyItem = item as any;
        const name = anyItem.contractName || anyItem.name || '';
        const url = anyItem.contractUrl || anyItem.url || '';
        const contentType = anyItem.contentType != null ? anyItem.contentType : anyItem.type;
        return {
          name,
          url,
          type: contentType === ContractContentTypeEnum.PDF
            ? ContractTypeEnum.PDF : ContractTypeEnum.HTML,
        };
      })
    ));

    /** 按钮是否禁用 */
    const isButtonDisabled = computed(() => (
      countdown.value > 0
      || creditStatus.value === PageStatusEnum.PROCESSING
    ));

    /** 按钮文案 */
    const buttonText = computed(() => {
      if (countdown.value > 0) {
        return `已阅读并同意协议（${countdown.value}s）`;
      }
      if (creditStatus.value === PageStatusEnum.PROCESSING) {
        return '授信中...';
      }
      if (creditStatus.value === PageStatusEnum.SUCCEEDED) {
        return '去使用';
      }
      return '已阅读并同意协议';
    });

    /**
     * 启动倒计时
     */
    const startCountdown = () => {
      if (countdownTimer) {
        clearInterval(countdownTimer);
      }
      countdown.value = 5;
      countdownTimer = window.setInterval(() => {
        countdown.value -= 1;
        if (countdown.value <= 0) {
          if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
          }
        }
      }, 1000);
    };

    /**
     * 轮询授信状态
     */
    const polling = pollingStatus({
      // creditTaskId,
      from: props.from,
      taskId: () => taskId.value,
      onStatusUpdate: (status) => {
        creditStatus.value = status;
      },
      onSuccess: async (res) => {
        // 授信成功
        if (res?.jumpUrl) {
          successJumpUrl.value = res.jumpUrl;
          emit('apply-success', res);
          openThirdPage(res.jumpUrl);
        } else {
          Toast('未能获取到跳转地址，请稍后再试');
        }
      },
      onFailed: () => {
        Toast('本次消费分期额度审核失败，保持良好信用下次再试');
        emit('apply-fail');
      },
      onTimeout: () => {
        Toast('未查询到开通结果');
      },
    });

    /**
     * 请求分期商城进件接口
     */
    const requestApply = async (showRetentionDialog: boolean = false) => {
      try {
        if (!showRetentionDialog) {
          creditStatus.value = PageStatusEnum.PROCESSING;
        }


        let shoppingMallCommodityList: string[] = [];
        let overLoanCommodityList: string[] = [];

        if (isPureSemiProcessProtocol.value) {
          overLoanCommodityList = pureOverLoanLocalChannelList.value
            .filter((c) => c.isSelected && (c.contractList || []).length > 0 && !!c.productId)
            .map((c) => c.productId);
        }
        if (isPureShoppingMallProtocol.value) {
          shoppingMallCommodityList = shoppingMallProtocolProductIds.value;
        }

        if (isShoppingMallAndSemiProcessProtocol.value) {
          shoppingMallCommodityList = shoppingMallProtocolProductIds.value;
          overLoanCommodityList = isOverLoanSelectedWhenBoth.value
            ? semiProcessProtocolProductIds.value
            : [];
        }

        // 调用中收授信申请接口（商城授信场景）
        const response = await applyMiddleIncomeCredit({
          from: props.from as any,
          shoppingMallCommodityList,
          overLoanCommodityList,
          scene: props.scene,
          incompleteInfo: props.incompleteInfo,
          applyMode: props.dispatchResult?.applyMode,
          priorityLevel: props.dispatchResult?.priorityLevel,
          taskId: taskId.value,
        });

        if (response?.taskId) {
          taskId.value = response.taskId;
          /** 非挽留弹窗场景，成功执行回调
           * 挽留弹窗场景，内部自己处理
           */
          if (!showRetentionDialog) {
            /** 申请成功，执行申请成功回调 */
            emit('apply-success', response);
          }
        } else {
          if (response?.businessErrorCode === 300002) {
            jumpToVerifyCredit(VerifySceneEnum.PRE_CREDIT_FQ_SHOPPING, {
              openMode: OpenVerifyPageMode.POPUP_SHOW,
              successCb: async () => {
                /** 如果是商城 + 半流程协议，且没有勾选借款优选协议，弹弹窗 */
                if (isShoppingMallAndSemiProcessProtocol.value) {
                  if (!isOverLoanSelectedWhenBoth.value) {
                    await requestApply(true);
                    /** 有商城订单的时候，才弹挽留弹窗；避免重复弹窗 */
                    if (taskId.value) {
                      Dialog.alert({
                        title: '借款优选协议',
                        message: '为您推荐更多优选机构，同意协议有机会获得更多额度',
                        confirmButtonText: '确认',
                        onEvent: (eventName) => {
                          if (eventName === 'closeIconClick') {
                            // eslint-disable-next-line no-console
                            console.error('taskId', taskId.value);
                            emit('apply-success', { taskId: taskId.value });
                          }
                          if (eventName === 'confirm') {
                            isOverLoanSelectedWhenBoth.value = true;
                          }
                        },
                      });
                    }
                    return;
                  }
                }

                // 发起授信申请
                await requestApply();
              },
            });
            return;
          }
          Toast('申请失败，请稍后重试');
          creditStatus.value = PageStatusEnum.INIT;
        }
      } catch (error: any) {
        /** 兼容需要补充资料的场景 */
        if (error.code === 300002) {
          jumpToVerifyCredit(VerifySceneEnum.PRE_CREDIT_FQ_SHOPPING, {
            openMode: OpenVerifyPageMode.POPUP_SHOW,
            successCb: async () => {
              /** 如果是商城 + 半流程协议，且没有勾选借款优选协议，弹弹窗 */
              if (isShoppingMallAndSemiProcessProtocol.value) {
                if (!isOverLoanSelectedWhenBoth.value) {
                  await requestApply(true);
                  /** 有商城订单的时候，才弹挽留弹窗；避免重复弹窗 */
                  if (taskId.value) {
                    Dialog.alert({
                      title: '借款优选协议',
                      message: '为您推荐更多优选机构，同意协议有机会获得更多额度',
                      confirmButtonText: '确认',
                      onEvent: (eventName) => {
                        if (eventName === 'closeIconClick') {
                          // eslint-disable-next-line no-console
                          console.error('taskId', taskId.value);
                          emit('apply-success', { taskId: taskId.value });
                        }
                        if (eventName === 'confirm') {
                          isOverLoanSelectedWhenBoth.value = true;
                        }
                      },
                    });
                  }
                  return;
                }
              }

              // 发起授信申请
              await requestApply();
            },
          });
          return;
        }
        Toast('申请失败，请稍后重试');
        creditStatus.value = PageStatusEnum.INIT;
      }
    };

    /**
     * 处理申请按钮点击
     */
    const handleApply = async () => {
      // 如果在倒计时或授信中，不处理
      if (isButtonDisabled.value) {
        return;
      }

      if (isPureShoppingMallProtocol.value && shoppingMallProductIds.value.length > 0) {
        ubtPageButtonNew(router.currentRoute.meta?.pageId as string, shopMallAgreementPopupClick, {
          from: props.from,
          productIds: shoppingMallProductIds.value,
        });
      }
      if (isPureSemiProcessProtocol.value && semiProcessProductIds.value.length > 0) {
        ubtPageButtonNew(router.currentRoute.meta?.pageId as string, dcHalfApplyAgreementClick, {
          from: props.from,
          productIds: semiProcessProductIds.value,
        });
      }

      // 如果已经授信成功，跳转
      if (creditStatus.value === PageStatusEnum.SUCCEEDED) {
        if (successJumpUrl.value) {
          openThirdPage(successJumpUrl.value);
        } else {
          Toast('未能获取到跳转地址，请稍后再试');
        }
        return;
      }

      /** 如果是商城 + 半流程协议，且没有勾选借款优选协议，弹弹窗 */
      if (isShoppingMallAndSemiProcessProtocol.value) {
        ubtPageButtonNew(router.currentRoute.meta?.pageId as string, shopMallAgreementPopupClick, {
          from: props.from,
          productIds: semiProcessProductIds.value,
        });
        if (isOverLoanSelectedWhenBoth.value) {
          ubtPageButtonNew(router.currentRoute.meta?.pageId as string, dcHalfApplyAgreementClick, {
            from: props.from,
            productIds: semiProcessProductIds.value,
          });
        }
        if (!isOverLoanSelectedWhenBoth.value) {
          await requestApply(true);
          /** 有商城订单的时候，才弹挽留弹窗；避免重复弹窗 */
          if (taskId.value) {
            Dialog.alert({
              title: '借款优选协议',
              message: '为您推荐更多优选机构，同意协议有机会获得更多额度',
              confirmButtonText: '确认',
              onEvent: (eventName) => {
                if (eventName === 'closeIconClick') {
                  // eslint-disable-next-line no-console
                  console.error('taskId', taskId.value);
                  emit('apply-success', { taskId: taskId.value });
                }
                if (eventName === 'confirm') {
                  isOverLoanSelectedWhenBoth.value = true;
                }
              },
            });
          }
          return;
        }
      }

      // 发起授信申请
      await requestApply();
    };

    onMounted(() => {
      // 组件挂载后启动倒计时
      startCountdown();
      if (shoppingMallProductIds.value.length > 0) {
        ubtModuleExposeNew(router.currentRoute.meta?.pageId as string,
          shopMallAgreementPopupExpose, {
            from: props.from,
            productIds: shoppingMallProductIds.value,
          });
      }
      if (semiProcessProductIds.value.length > 0) {
        ubtModuleExposeNew(router.currentRoute.meta?.pageId as string, dcHalfApplyAgreementExpose, {
          from: props.from,
          productIds: semiProcessProductIds.value,
        });
      }

      if (isPureSemiProcessProtocol.value) {
        const newList = semiProcessContractList.value.map((channel) => ({
          ...channel,
          isSelected: true, // 默认全部选中
        }));
        pureOverLoanLocalChannelList.value = newList as ChannelContractInfo[];
      }
    });

    onBeforeUnmount(() => {
      // 清理定时器
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
      // 停止轮询
      polling.cancel();
    });

    return {
      countdown,
      creditStatus,
      formatAmount,
      adaptedContractList,
      shoppingMallContractList,
      mergedShoppingMallContractList,
      shoppingMallProductIds,
      semiProcessContractList,
      semiProcessProductIds,
      contractListFromProtocolResult,
      pureOverLoanLocalChannelList,
      hasShoppingMallProtocol,
      hasSemiProcessProtocol,
      isPureShoppingMallProtocol,
      isPureSemiProcessProtocol,
      isShoppingMallAndSemiProcessProtocol,
      tipsCopy,
      isOverLoanSelectedWhenBoth,
      isButtonDisabled,
      buttonText,
      handleApply,
      PageStatusEnum,
      handleSelectChannel,
    };
  },
});
